import {Injectable} from '@angular/core';
import {Constants} from '../constants';
import {CookieService} from 'ngx-cookie-service';
import {Md5} from 'ts-md5';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class ConversationId {
    /**
     * Conversation ID cookie name
     * @var {string}
     */
    private _conversationIdCookieName: string = Constants.COOKIE_CONVERSATION_ID;

    /**
     * Class constructor
     *
     * @param _cookieService
     */
    public constructor(
        private _cookieService: CookieService
    ) {
        this._checkAndSetConversationIdCookie();
    }

    /**
     * Gets the conversation ID from a cookie
     *
     * @returns {string}
     */
    public getConversationId(): string {
        return this._cookieService.get(this._conversationIdCookieName);
    }

    /**
     * Checks if conversation ID cookie is present and sets it if not
     *
     * @private
     * @returns {void}
     */
    private _checkAndSetConversationIdCookie(): void {
        if (!this._cookieService.check(this._conversationIdCookieName)) {
            const conversationId = moment().unix().toString();

            this._cookieService.set(
                this._conversationIdCookieName,
                Md5.hashStr(conversationId).toString(),
                0,
                '',
                '',
                false,
                'Strict'
            );
        }
    }
}
